import React, { useContext } from "react";
import { ActiveLoaderBrandingContext } from "../context/LoaderBrandingContext";
import LoaderBrand from "./LoaderBrand";
import "./globalRequestLoader.css";

/**
 * Professional loading state.
 *   <PageLoader label="Loading integrations…" />                 merchant identity and loading status
 *   <PageLoader label="Loading ledger…" rows={4} />              spinner + skeleton rows
 *   <PageLoader inline label="Saving…" />                        small inline spinner
 *   <PageLoader fullPage label="Loading workspace…" />           fills the screen
 */
export default function PageLoader({ label = "Loading…", hint, rows = 0, inline = false, fullPage = false, className = "", showBrand = true }) {
  const brand = useContext(ActiveLoaderBrandingContext);
  const branded = showBrand && typeof brand?.name === "string" && !!brand.name.trim();
  if (inline) {
    return (
      <span role="status" aria-live="polite" className={`pl-inline ${className}`}>
        <span className="pl-spinner pl-spinner-sm" aria-hidden="true" />
        <span>{label}</span>
      </span>
    );
  }
  const status = <><span className="pl-spinner" aria-hidden="true" /><div className="pl-text">
    <div className="pl-label">{label}</div>{hint && <div className="pl-hint">{hint}</div>}
  </div></>;
  return (
    <div role="status" aria-live="polite" aria-busy="true" className={`pl-wrap${fullPage ? " pl-full" : ""} ${className}`}>
      <div className={branded ? "pl-merchant-loader" : "pl-card"}>
        {branded ? <><LoaderBrand brand={brand} /><div className="pl-merchant-status">{status}</div></> : status}
      </div>
      {rows > 0 && (
        <div className="pl-skel" aria-hidden="true">
          {Array.from({ length: rows }).map((_, i) => <div key={i} className="pl-row"><span className="pl-bar" /><span className="pl-bar" /><span className="pl-bar" /></div>)}
        </div>
      )}
    </div>
  );
}
